import { MAX_ZALOHA, zalohaVyska, zvolMaxZaloha } from './vyjezd2026Rozlozeni';

/**
 * Kolik karet odpovedi se vejde do vysky obrazovky v presetech standard / custom. Kiosek
 * nescrolluje, proto co se nevejde, nahradi radek „+ X dalsich“ (jinak by treti rada karet
 * byla useknuta bez jakehokoli upozorneni).
 */
const PADDING = 8;

/**
 * Vyska CounterChipu v px (root 16 px): padding 12 + 12, popisek 1rem, cislo 3.5rem + okraj 4 px.
 * Pilulka „zaloha N“ pod cislem (jen u JEDU, pokud je zaloha): okraj 4 + 1.05rem * 1.2 + padding 3.2.
 */
export const COUNTER_VYSKA = 100;
export const COUNTER_PILULKA = 27.4;

export interface KartyVstup {
    /** Vyska kontejneru odpovedi (px); 0 = jeste nezmereno, nic se neorezava. */
    vyska: number;
    /** Vyska jednoho radku karet vcetne mezery (px). */
    radekH: number;
    /** Kolik karet je vedle sebe v jednom radku. */
    sloupcu: number;
    pocetJedou: number;
    pocetNejedou: number;
    pocetZaloha: number;
    /**
     * Minimalni vyska sloupce Jedou dana CounterChipem (px); sloupec je vzdy aspon tak vysoky,
     * i kdyz karet je malo. 0 / vynechano = bez chipu (STRIPE).
     */
    counterH?: number;
}

export interface KartyKapacita {
    /** Kolik karet Jedou se ukaze (cele pocet = vse se vejde). */
    maxJedou: number;
    maxNejedou: number;
    /** `maxViditelnych` pro ZalohaSkupina. */
    maxZaloha: number;
}

/** Sestavi pocet viditelnych karet; radek „+ X dalsich“ zabere jeden radek karet. */
const viditelne = (pocet: number, radku: number, sloupcu: number): number => {
    if (pocet <= radku * sloupcu) return pocet;
    return Math.max(1, radku - 1) * sloupcu;
};

export const spocitejKapacituKaret = ({
    vyska, radekH, sloupcu, pocetJedou, pocetNejedou, pocetZaloha, counterH = 0,
}: KartyVstup): KartyKapacita => {
    if (vyska <= 0 || radekH <= 0) {
        return { maxJedou: Number.MAX_SAFE_INTEGER, maxNejedou: Number.MAX_SAFE_INTEGER, maxZaloha: MAX_ZALOHA };
    }
    const sl = Math.max(1, sloupcu);
    const dostupne = vyska - PADDING;
    const radkuJedou = (maxZaloha: number) => {
        const volno = dostupne - zalohaVyska(pocetZaloha, maxZaloha);
        // Sloupec Jedou je vysoky aspon jako CounterChip; kdyz se chip nevejde, zadne karty se nepocitaji.
        return volno < counterH ? 0 : Math.floor(volno / radekH);
    };

    const maxZaloha = zvolMaxZaloha(pocetZaloha, pocetJedou, (m) => radkuJedou(m) * sl);
    return {
        maxJedou: viditelne(pocetJedou, radkuJedou(maxZaloha), sl),
        maxNejedou: viditelne(pocetNejedou, Math.floor(dostupne / radekH), sl),
        maxZaloha,
    };
};

/** Spocita sloupce z computed `grid-template-columns` (jen vyresene px hodnoty; jinak 0). */
export const spocitejSloupce = (gridTemplateColumns: string): number =>
    gridTemplateColumns.split(/\s+/).filter((t) => /^[\d.]+px$/.test(t)).length;
